import React, { useState } from 'react';
import { searchVideos } from '../lib/metadata';
import { COLORS, SPACING } from '../styles/theme';

export function Search({ onSelectVideo }: { onSelectVideo: (hash: string) => void }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<any[]>([]);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const q = e.target.value;
    setQuery(q);

    if (q.trim()) {
      const found = searchVideos(q);
      setResults(found);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  };

  const handleSelectVideo = (hash: string) => {
    onSelectVideo(hash);
    setQuery('');
    setShowResults(false);
  };

  return (
    <div style={{
      border: `2px outset ${COLORS.highlight}`,
      marginBottom: SPACING.lg,
      backgroundColor: COLORS.panel,
      overflow: 'hidden',
      position: 'relative'
    }}>
      <div style={{
        backgroundColor: COLORS.accent,
        color: '#fff',
        padding: `${SPACING.xs} ${SPACING.sm}`,
        fontSize: '9px',
        fontWeight: 700,
        borderBottom: `2px solid ${COLORS.highlight}`,
        userSelect: 'none'
      }}>
        Search
      </div>

      <div style={{ padding: SPACING.lg, backgroundColor: COLORS.bg }}>
        <input
          type="text"
          placeholder="Search videos..."
          value={query}
          onChange={handleSearch}
          style={{
            width: '100%',
            padding: SPACING.md,
            backgroundColor: '#fff',
            color: '#000',
            border: `2px inset ${COLORS.highlight}`,
            fontFamily: 'monospace',
            fontSize: '11px',
            boxSizing: 'border-box'
          }}
        />

        {showResults && (
          <div style={{
            marginTop: SPACING.sm,
            border: `1px solid ${COLORS.border}`,
            backgroundColor: COLORS.bg,
            maxHeight: '200px',
            overflowY: 'auto'
          }}>
            {results.length === 0 ? (
              <p style={{ padding: SPACING.lg, margin: 0, color: COLORS.textMuted, fontSize: '9px' }}>
                No results
              </p>
            ) : (
              results.map(video => (
                <button
                  key={video.hash}
                  onClick={() => handleSelectVideo(video.hash)}
                  style={{
                    display: 'block',
                    width: '100%',
                    padding: SPACING.md,
                    backgroundColor: COLORS.bg,
                    color: COLORS.accent,
                    border: 'none',
                    borderBottom: `1px solid ${COLORS.border}`,
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '9px',
                    fontWeight: 700,
                    fontFamily: 'monospace',
                    textDecoration: 'underline'
                  }}
                >
                  {video.title}
                </button>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
